'use es6';

import { Record, Set as ImmutableSet } from 'immutable';
import { getDateRangePresetForString, PRESET_TYPES } from '../../lib/AdsSimpleDateRange';
import { AttributionViews } from '../../lib/Constants';
import AdAccountIdentityRecord from '../ad-accounts/AdAccountIdentityRecord.js';
const CampaignListFilterRecord = Record({
  timeRange: getDateRangePresetForString(PRESET_TYPES.LAST_THIRTY_DAYS),
  statuses: ImmutableSet(),
  adAccounts: ImmutableSet(),
  attributionView: AttributionViews.FIRST_FORM_SUBMISSION
});
export const fromGlobalFilters = ({
  timeRange,
  statuses,
  adAccounts,
  attributionView
}) => CampaignListFilterRecord({
  timeRange,
  statuses,
  attributionView,
  adAccounts: adAccounts.map(({
    accountId,
    network
  }) => AdAccountIdentityRecord({
    accountId,
    network
  }))
});
export default CampaignListFilterRecord;